const xs = 0
const sm = 576
const md = 768
const lg = 992
const xl = 1200

export { xs, sm, md, lg, xl }
